import { ReactElement } from "react";
import {
	ConvertedTextInputProps,
	convertibleTextInput
} from "../ConvertibleTextInput/ConvertibleTextInput";
import {
	integerConverter,
	numberConverter
} from "client/Forms/converters";

type NumberInputProps = ConvertedTextInputProps<number | null> & {
	shouldAcceptFloatNumbers?: boolean;
};

export const NumberInput = (props: NumberInputProps): ReactElement => {
	const {
		shouldAcceptFloatNumbers = false,
		...otherProps
	} = props;

	return shouldAcceptFloatNumbers
		? (
			<FloatInput
				{...otherProps}
				inputMode="decimal"
			/>
		) : (
			<IntegerInput
				{...otherProps}
				inputMode="numeric"
			/>
		);
};
NumberInput.displayName = "NumberInput";

const IntegerInput: (props: ConvertedTextInputProps<number | null>) => ReactElement | null = convertibleTextInput<number | null>(integerConverter);
const FloatInput: (props: ConvertedTextInputProps<number | null>) => ReactElement | null = convertibleTextInput<number | null>(numberConverter);